import { useContext } from "react";
import { AuthContext } from "./AuthContext";
import { Navigate } from "react-router-dom";

export default function AuthRoute({ children }: React.PropsWithChildren<{}>) {
    const { authenticated } = useContext(AuthContext);
    const redirectUrl = `/authorisation/login?return=${encodeURI(window.location.href)}`

    return authenticated ? children : <Navigate to={redirectUrl} />;
}